export const CountDownTime = 30;
export const CountDownTimeJp = 300;
